import { usePromotePageState } from 'src/app/pages/promote/pageContext';

export type Result = (amount: number) => void;

export function useSetAmount(): Result {
	const [, { setAmount }] = usePromotePageState();

	return setAmount;
}
